import { login } from '@/api/login'
import smCrypto from '@/utils/smCrypto'
import { setToken } from '@/utils/auth'

// 免登录默认账号：进入首页或退出登录后自动走一次登录接口
export const autoLogin = async () => {
  try {
    const res = await login({
      account: 'qnzy',
      password: smCrypto.doSm2Encrypt('123456'),
      tenantId: 'qnzy'
    })
    if (res.code === 200 && res.data && res.data.token) {
      setToken(res.data.token)
      return true
    }
    console.error('自动登录失败：', res.message)
  } catch (e) {
    console.error('自动登录异常：', e)
  }
  return false
}
